// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { Browser } from '@capacitor/browser'
import { Capacitor } from '@capacitor/core'
import { createDomain, createStore, sample } from 'effector'
import { createGate } from 'effector-react'
import { viewerModel } from '~/entities/viewer'
import { AxiosErrorType, Driver } from '~/shared/api'
import { logger } from '~/shared/lib/logger'
import { snackbarEnqueued } from '~/shared/lib/notifications'

const domain = createDomain('entities.okoDrive')

export const Gate = createGate()

export const getOkodriveDeeplinkFx = domain.createEffect<
  void,
  string | null,
  AxiosErrorType
>({
  handler: Driver.getOkodriveDeeplink,
})

export const openOkodriveDeeplink = domain.createEvent()

export const openOkodriveDeeplinkFx = domain.createEffect<void, string | null>({
  async handler() {
    const link = await Driver.getOkodriveDeeplink()

    if (!link) {
      return null
    }

    if (Capacitor.isNativePlatform()) {
      await Browser.open({ url: link })
    } else {
      window.open(link, '_blank')
    }

    return link
  },
})

export const $okodriveLink = createStore<string | null>(null)
  .on(getOkodriveDeeplinkFx.doneData, (_, link) => link)
  .on(openOkodriveDeeplinkFx.doneData, (_, link) => link)
  .reset([Gate.close, viewerModel.signOut, getOkodriveDeeplinkFx.fail])

export const $hasOkodriveDeeplink = $okodriveLink.map((link) => Boolean(link))

sample({
  clock: Gate.open,
  target: getOkodriveDeeplinkFx,
})

sample({
  clock: openOkodriveDeeplink,
  target: openOkodriveDeeplinkFx,
})

sample({
  clock: openOkodriveDeeplinkFx.doneData,
  filter: (link): link is null => link === null,
  fn: () => ({
    message: 'Ссылка ОкоДрайв недоступна',
    variant: 'danger' as const,
  }),
  target: snackbarEnqueued,
})

sample({
  clock: openOkodriveDeeplinkFx.failData,
  fn(error) {
    logger.error(error)
    return {
      message: 'Не удалось открыть ОкоДрайв',
      variant: 'danger' as const,
    }
  },
  target: snackbarEnqueued,
})

getOkodriveDeeplinkFx.failData.watch((error) => {
  logger.error(error)
})
